import React from 'react'

import { BsFillPlayFill } from "react-icons/bs";

const AudioComponent = ({
    audioRef,
    getIsPlay,
    setIsPlay,
}) => {
    return (
        <>
            <audio src="./relaxing_playlist_1.mp3" ref={audioRef}></audio>
            <div
                className={`fixed z-[51] w-[8vh] h-[8vh] bg-gray-700 rounded-full flex items-center justify-center  ${!getIsPlay && `animate-pulse bg-[#E65445]`}`}
                style={{
                    "left": "5%",
                    "top": "88%"
                }}
                onClick={() => {
                    if (getIsPlay) {
                        audioRef.current.pause()
                        setIsPlay(false)
                    } else {
                        audioRef.current.play()
                        setIsPlay(true)
                    }
                }}
            >
                <BsFillPlayFill className={`ml-[0.8vh] w-[5vh] h-[5vh] text-white ${getIsPlay && `animate-pulse`}`} /></div>
        </>
    )
}

export default AudioComponent